var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "m12 10.822 4.125-4.125 1.178 1.178L13.18 12l4.124 4.125-1.178 1.178L12 13.178l-4.125 4.125-1.178-1.178L10.822 12 6.697 7.875l1.178-1.178L12 10.822Z", fill: "#969390" }));
export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEyIDEwLjgyMiA0LjEyNS00LjEyNSAxLjE3OCAxLjE3OEwxMy4xOCAxMmw0LjEyNCA0LjEyNS0xLjE3OCAxLjE3OEwxMiAxMy4xNzhsLTQuMTI1IDQuMTI1LTEuMTc4LTEuMTc4TDEwLjgyMiAxMiA2LjY5NyA3Ljg3NWwxLjE3OC0xLjE3OEwxMiAxMC44MjJaIiBmaWxsPSIjOTY5MzkwIi8+PC9zdmc+";
